app.controller('CheckoutPaymentController', [
											'$scope',
											'Config',
											'CacheFactory',
											'delivery',
											'$window',
											'helper',
											'cart',
											'payment',
											'stripe',
											'$timeout',
											'quote',
											'$http',
											'$interval',
											'toaster',
function($scope,Config,CacheFactory,delivery,$window,helper,cart,payment,stripe,$timeout, quote, $http, $interval, toaster){
  $scope.base_url = Config.base_url;
  $scope.cart = cart.getCart();
  $scope.globalTime = moment().toDate();
  $scope.stripeService = stripe;
  $scope._error = false;
  $scope.countries = [];
  $scope.payment = {};
  $scope.po_number = null;
  $scope.steps = {
	'billing':{
	'active':true,
	'filled':false,
	},
	'payment':{
	'active':false,
	'filled':false,
	}
  };

  $scope.address = {
		billing:{
		  lift:'',
		  liftFit:'',
		  floor:'',
		  parkingRestrictions:'None',
		  additionalInfo:'',
		  country:'GB'
		}
	  };

  $scope.craftyResults = {
	billing:{
	foundAddresses:[],
	selectedAddress:'',
	error:null
	}
  };

  $scope.thisDate = {
	  'endtime' : null,
	  'set' : false
  };

  $scope.CountDown = {
	days: 0,
	hours: 0,
	minutes: 0,
	seconds: 0,
	getTimeRemaining: function(endtime) {
	  var t = Date.parse(endtime) - Date.parse(new Date());
	  var seconds = Math.floor((t / 1000) % 60);
	  var minutes = Math.floor((t / 1000 / 60) % 60);
	  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
	  var days = Math.floor(t / (1000 * 60 * 60 * 24));
	  return {
		'total': t,
		'days': days,
		'hours': hours,
		'minutes': minutes,
		'seconds': seconds
	  };
	},



	initializeClock: function (endtime) {
		var timeExpired = false;
	
		function updateClock() {

			$scope.thisDate.endtime = endtime;

			var t = $scope.CountDown.getTimeRemaining(endtime);
			var dateDifference = moment($scope.quote.created_on).add($scope.quote.tlif.tlif_min_count, 'm').add($scope.quote.server_date_offset, 'milliseconds').diff(new Date);
			$scope.$applyAsync();
			$scope.CountDown.days = t.days < 10 ? '0' + t.days : t.days;
			$scope.CountDown.hours = ('0' + t.hours).slice(-2);
			$scope.CountDown.minutes = ('0' + t.minutes).slice(-2);
			$scope.CountDown.seconds = ('0' + t.seconds).slice(-2);

			
			if(t.total == 1000){
				$scope.updateTlifStatus();
			}

			if ((t.total <= 0) || ($scope.quote.discountCode)) {

				$interval.cancel(timeinterval);
				$scope.quote.tlif.enabled = false;
				// console.log('Time ran out');
				$scope.checkTlifPrice();
				if(timeExpired == false) {
					toaster.pop('warning', "Quote Updated!", 'Sorry! Time has run out. Your discount has been revoked.');
			}
				timeExpired = true;
			
			} else {
				if ($scope.quote.tlif.enabled != true) {
					$scope.quote.tlif.enabled = true;
				}
			}
		}
		if (timeExpired == false){
			updateClock();
			var timeinterval = $interval(updateClock, 1000);
		}
	}
}


	$scope.$on('saveOrderEvent', function(event, data) {
		$scope.saveOrder(data.orderID,data.transID);
	})
  

  $scope.init = function(){

	helper.showTransLoader();
	setTimeout(function() {
		helper.hideTransLoader();
	}, 1000);
	
	//get country list
	quote.getCountryList().then(function(response) {
	  $scope.countries = response.data;
	 }, function(response) {
	//   console.log(response);
	 });

	//check for semi completed quotes from 
	if(helper.getParameterByName('quote-id')){
		$scope.retrieveQuote(helper.getParameterByName('quote-id'));
	}else{
		//check if the quote cache exist otherwise redirect to details page
		
		if(angular.isDefined($scope.cart) && $scope.cart.cartChanged == true) {
			$window.location.href = $scope.base_url + 'checkout/details';
		}
		else if(!angular.isDefined(CacheFactory.get('appCache').get('quote')) || !angular.isDefined(CacheFactory.get('appCache').get('cart'))){
		  $window.location.href = $scope.base_url+'checkout/details';
		}
		else if((!angular.isDefined(CacheFactory.get('appCache').get('quote')) || !angular.isDefined(CacheFactory.get('appCache').get('quote').quote_limitations)
				&& CacheFactory.get('appCache').get('quote').quote_limitations 
				&& CacheFactory.get('appCache').get('quote').quote_limitations.limitations == true)
			|| (!CacheFactory.get('appCache').get('quote').passedQuoteStage)){
			$window.location.href = $scope.base_url+'checkout/quote';
		}
		else{
		  $scope.quote = CacheFactory.get('appCache').get('quote');

		  if ((typeof $scope.quote.tlif !== 'undefined')&&($scope.quote.tlif)) {
				$scope.quote.tlif.paused=false;
				if($scope.thisDate.endtime == null){
					var deadline = moment($scope.quote.created_on).add($scope.quote.tlif.tlif_min_count, 'm').add($scope.quote.server_date_offset,'milliseconds').toDate();
				}
				else {
					var deadline = moment($scope.thisDate);
				}
				$scope.CountDown.initializeClock(deadline);
			}

		  $scope.deliveryDate = moment.unix($scope.quote.deliveryDateTimestamp+ ($scope.quote.deliveryDateOffset*86400) ).format("DD/MM/YYYY");
		  $scope.collectionDate = moment.unix($scope.quote.collectionDateTimestamp+ ($scope.quote.collectionDateOffset*86400) ).format("DD/MM/YYYY");
		  $scope.hireWeeks = ($scope.quote.hireDays!=1) ? Math.round(($scope.quote.hireDays/7)+0.35) : $scope.quote.hireDays;

		  //get cached addresses
		  $scope.address.billing.contactName = $scope.quote.name;

		  //prefill postcode field
		  $scope.address.billing.postCode = $scope.quote.deliveryPostcode;

		  //get cached delivery data
		  if(angular.isDefined(CacheFactory.get('appCache').get('delivery'))){
			$scope.transport = CacheFactory.get('appCache').get('delivery'); 
		  }

		  if(angular.isDefined(CacheFactory.get('appCache').get('addressData'))){
			$scope.address = CacheFactory.get('appCache').get('addressData').address; 
			$scope.steps = CacheFactory.get('appCache').get('addressData').steps; 
		  }

		  $scope.updateTotals();
		  //check if the current step is payment then init paypal btn
		  if($scope.steps.payment.active){
			$timeout(function(){
			  //init paypal button
			  $scope.initPaypalBtn();
			}, 100);
		  }

		  	if($scope.steps.payment.active){
				$scope.initStripe();
			}
		}

	}
	//open the accordion if the screen width is more than 650 pixels
	if($( window ).width()>650){
		$('.collapse').collapse();
		$('#tap-click').text('click');
	}
	setTimeout(function () {
		// console.log($scope);
	}, 5000);
  }

  $scope.initStripe = function(){
		setTimeout(function(){
			var stripe = Stripe(stripePublishable);
            var elements = stripe.elements();
            var cardNumber = elements.create('cardNumber');
            var cardExpiry = elements.create('cardExpiry');
            var cardCvc = elements.create('cardCvc');
            cardNumber.mount('#cardNumber');
            cardExpiry.mount('#cardExpiry');
            cardCvc.mount('#cardCvc');

            // Create a token when the form is submitted.
            var form = document.getElementById('payment-form');
            form.addEventListener('submit', function(e) {
              e.preventDefault();
              $scope.createToken(stripe,cardNumber);
            });
		}, 100);
	}

	$scope.createToken = function(stripe,cardNumber){
	  	var data = {
	  		'quote':$scope.quote,
			'address':$scope.address,
			'cart':$scope.cart,
			'hire_weeks':$scope.hireWeeks,
			'deliveryChecklist':$scope.transport
	  	};
	  	$scope.stripeService.createToken(data,cardNumber,stripe);
	}

  $scope.retrieveQuote = function(quoteID){
	//check if the quote is valid and not expired
	helper.showTransLoader();
	quote.retrieveQuote(quoteID,helper.getParameterByName('token')).then(function(response) {
			if(helper.getParameterByName('token')!=$('#user_token').val()){
				location.reload();
			}else{
				//if valid then retrive it
				//clear JS session & add quote to the session
				cart.content = [];
				CacheFactory.get('appCache').removeAll();
				var quoteRes = response.data;

				//set quote data
				$scope.quote = quoteRes;
				$scope.checkLimitations();
				$scope.hireWeeks = ($scope.quote.hireDays!=1) ? Math.round(($scope.quote.hireDays/7)+0.35) : $scope.quote.hireDays;
				$scope.deliveryDate = moment.unix($scope.quote.deliveryDateTimestamp+ ($scope.quote.deliveryDateOffset*86400) ).format("DD/MM/YYYY");
				$scope.collectionDate = moment.unix($scope.quote.collectionDateTimestamp+ ($scope.quote.collectionDateOffset*86400) ).format("DD/MM/YYYY");
				$scope.address.billing.contactName = $scope.quote.name;
				//update cache variables
				CacheFactory.get('appCache').put('quote',quoteRes);
				CacheFactory.get('appCache').put('hireDays',$scope.quote.hireDays);
				CacheFactory.get('appCache').put('hireWeeks',$scope.hireWeeks);
				CacheFactory.get('appCache').put('deliveryDate',moment.unix($scope.quote.deliveryDateTimestamp+ ($scope.quote.deliveryDateOffset*86400) ).format("YYYY-MM-DD"));
				CacheFactory.get('appCache').put('collectionDate',moment.unix($scope.quote.collectionDateTimestamp+ ($scope.quote.collectionDateOffset*86400) ).format("YYYY-MM-DD"));
				cart.setCart(quoteRes.cart);
				$scope.showBacs();
				CacheFactory.get('appCache').put('retrievedQuote',true);
				  	//get surcharges
					surchargesData =   {
					  brand:Config.brand_key,
					  deliveryPostcode:$scope.quote.deliveryPostcode,
					  collectionPostcode:$scope.quote.deliveryPostcode
					}
					delivery.getSurcharges(surchargesData).then(function(response) {
					  $scope.surcharges = response.data;

					  //set delivery session variables
					  $scope.transport = $scope.quote.transportOptions;

					  $timeout(function(){
						$scope.transport = helper.timedHackCalc($scope.transport, $scope.surcharges);
						//cache delivery and collection options
						CacheFactory.get('appCache').put('delivery',$scope.transport);
						
					   }, 50);
					   var tlif = {
						enabled:false
					}
					$scope.quote.tlif = tlif;
					//update totals
					$scope.updateTotals();
					  
					}, function(response) { 
					//   console.log(response);
					});
					$http({
						method: 'POST',
						url: Config.api_url+'quote/check-limitations',
						data: {data: CacheFactory.get('appCache').get('quote')},
						headers:{
							'authorization':Config.api_key
						}
					  }).then(function(response) {
						  $scope.quote.quote_limitations = response.data
						  $scope.checkLimitations();
					})
			}

		}, function(response) {
		if(response.status==406){
			//if not then show an error
			$scope.retrievedQuote = response.data;
			alert('Your quote expired. Please add new products to get a quote.');
			helper.hideTransLoader();
			$window.location.href = $scope.base_url + 'checkout/details';
		}
	  });
   }

  $scope.genPaymentLink = function(){
	var linkURL = prompt('Payment Completion URL:', Config.base_url+'checkout/payment?quote-id='+$scope.quote.webQuoteID+'&token='+$scope.quote.token);
  }

  $scope.updateTotals = function(){

	if (($scope.quote.tlif==null) || (typeof $scope.quote.tlif != 'object')||(typeof $scope.quote.tlif.enabled == 'undefined')){

		var tlif = {
			enabled:false
		};
		$scope.quote.tlif = tlif;
	  }

	//check for install and derig and add their cost
	totalExVat = parseFloat($scope.quote.totalExVat);
	discountedTotalExVat = parseFloat($scope.quote.discountedTotalExVat);

	if ($scope.quote.tlif.enabled){
		var tlifTotalExVat = parseFloat($scope.quote.tlif.totalExVat);
	}

	if($scope.transport.delivery.install=='yes'){
		totalExVat += parseFloat($scope.transport.delivery.installCost);
		discountedTotalExVat += parseFloat($scope.transport.delivery.installCost);
		if ($scope.quote.tlif.enabled){
			tlifTotalExVat += parseFloat($scope.transport.delivery.installCost);
		}
	}

	if($scope.transport.collection.derig=='yes'){
		totalExVat += parseFloat($scope.transport.collection.derigCost);
		discountedTotalExVat += parseFloat($scope.transport.collection.derigCost);
		if ($scope.quote.tlif.enabled){
			tlifTotalExVat += parseFloat($scope.transport.collection.derigCost);
		}
	}
	if($scope.transport.delivery.option){
		totalExVat += parseFloat($scope.transport.delivery.option.price);
		discountedTotalExVat += parseFloat($scope.transport.delivery.option.price);
		if ($scope.quote.tlif.enabled){
			tlifTotalExVat += parseFloat($scope.transport.delivery.option.price);
		}
	}
	if($scope.transport.collection.option){
		totalExVat += parseFloat($scope.transport.collection.option.price);
		discountedTotalExVat += parseFloat($scope.transport.collection.option.price);
		if ($scope.quote.tlif.enabled){
			tlifTotalExVat += parseFloat($scope.transport.collection.option.price);
		}
	}
	
	$scope.quote.totalExVat = helper.formatMoney(totalExVat);
	$scope.quote.discountedTotalExVat = helper.formatMoney(discountedTotalExVat);
	$scope.quote.vat = helper.formatMoney((totalExVat*Config.vatRate)/100);
	$scope.quote.discountedVat = helper.formatMoney((discountedTotalExVat*Config.vatRate)/100);
	$scope.quote.totalIncVat = helper.formatMoney( parseFloat((totalExVat*Config.vatRate)/100) + parseFloat(totalExVat));
	$scope.quote.discountedTotalIncVat = helper.formatMoney(  parseFloat((discountedTotalExVat*Config.vatRate)/100) + parseFloat(discountedTotalExVat));

	if ($scope.quote.tlif.enabled){
		$scope.quote.tlif.totalExVat = helper.formatMoney(tlifTotalExVat);
		$scope.quote.tlif.vat = helper.formatMoney((tlifTotalExVat*Config.vatRate)/100);
		$scope.quote.tlif.totalIncVat = helper.formatMoney( parseFloat((tlifTotalExVat*Config.vatRate)/100) + parseFloat(tlifTotalExVat));
	}

  }

  $scope.place_bacs_order = function(){
	//show loader
	helper.showTransLoader();

	//save order in the DB and send email
	payment.incrementOrder($scope.quote.webQuoteID).then(function(response) {

	  $scope.saveOrder(response.data.orderId,'BACS'+response.data.orderId);

	}, function(response) {
	  if(response.status==400){
		//then there are some limitations
		$scope._error = true;
		helper.hideTransLoader();
	  }
	});
  }

  $scope.showBacs = function(){

	if($scope.quote.company == null || $scope.quote.company == ''){
		return false;
	}

	var endDate = moment.unix($scope.quote.deliveryDateTimestamp+ ($scope.quote.deliveryDateOffset*86400)).toDate();
	var startDate = moment().toDate();
	var result = -1;
	var currentDate = startDate;

	while (currentDate <= endDate)  {  
		var weekDay = currentDate.getDay();
		if(weekDay != 0 && weekDay != 6)
			result++;
		 currentDate.setDate(currentDate.getDate()+1); 
	}

	if(result >= 3 && $scope.quote.company != ''){
		$scope.showPoReference = true;
	}
	else {
		$scope.showPoReference = false;
	}

	if(result>=3){
	  return true;
	}else{
	  return false;
	}

	
  }


  $scope.saveOrder = function(orderId,transID){

	helper.showTransLoader();

	herbertFormattedAddresses = [];
	//convert Doris addresses to herbert addresses
	angular.forEach($scope.address, function(address, key) {
	  address = payment.convertDorisToHerbertAddress(address,$scope.quote);
	  herbertFormattedAddresses[key] = address;
	});

	var content = angular.copy($scope.cart.content);
	//go through cart and add the full link for product images
	angular.forEach(content, function(item, key) {
		  item.data.image = item.data.cart_image;
	});

	$scope.po_number = $('#po_number').val() != '' ? $('#po_number').val() : null;

	orderData = {
		  'brand':Config.brand_key,
		  'order-id':orderId,
		  'transaction-id': transID,
		  'cart':content,
		  'contact-name': $scope.quote.name,
		  'company-name': $scope.quote.company,
		  'email': $scope.quote.email,
		  'telephone': $scope.quote.telephone,
		  'delivery-date': moment.unix($scope.quote.deliveryDateTimestamp+ ($scope.quote.deliveryDateOffset*86400) ).format("YYYY-MM-DD"),
		  'collection-date': moment.unix($scope.quote.collectionDateTimestamp+ ($scope.quote.collectionDateOffset*86400) ).format("YYYY-MM-DD"),
		  'hire-days':$scope.quote.hireDays,
		  'cart-total-weight':cart.totalWeight(),
		  'user-agent':angular.element('#user_agent').val(),
		  'user-ip':angular.element('#user_ip').val(),
		  'product-total':$scope.quote.productTotal,
		  'billing-address':herbertFormattedAddresses.billing,
		  'damage-waiver': $scope.quote.damageWaiver,
		  'delivery-cost': $scope.quote.transport.delivery_charge,
		  'collection-cost': $scope.quote.transport.collection_charge,
		  'weekend-delivery': $scope.quote.weekendDelivery,
		  'weekend-delivery-cost': $scope.quote.transport.weekend_delivery_charge,
		  'weekend-collection': $scope.quote.weekendCollection,
		  'weekend-collection-cost': $scope.quote.transport.weekend_collection_charge,
		  'install': $scope.transport.delivery.install,
		  'install-cost': $scope.transport.delivery.installCost,
		  'derig': $scope.transport.collection.derig,
		  'derig-cost': $scope.transport.collection.derigCost,
		  'min-hire': $scope.quote.minHire,
		  'min-hire-balance': $scope.quote.minHireBalance,
		  'total-ex-vat':$scope.quote.totalExVat,
		  'vat':$scope.quote.vat,
		  'total-inc-vat':$scope.quote.totalIncVat,
		  'discount-code': $scope.quote.discountCode,
		  'discount-value': $scope.quote.discountValue,
		  'web-quote-id': $scope.quote.webQuoteID,
		  'click_and_collect': $scope.quote.click_and_collect,
		  'tlif':$scope.quote.tlif,
		  'carbon_footprint': $scope.quote.carbon_footprint,
		  'po_number': $scope.po_number,
		  }


		  //check if delivery and billing are the same
		  /*if(JSON.stringify($scope.address.billing) !== JSON.stringify($scope.address.delivery)){
			  orderData['delivery-address'] = herbertFormattedAddresses.delivery;
		  }

		  //also check if collection and delivery are the same
		  if(JSON.stringify($scope.address.delivery) !== JSON.stringify($scope.address.collection)){
			orderData['collection-address'] = herbertFormattedAddresses.collection;
		  }*/

		  //check for delivery and collection options
		  if($scope.transport.delivery.option){
			orderData['delivery-option-id'] = $scope.transport.delivery.option.carriage_surcharge_id;
			orderData['delivery-option-name'] = $scope.transport.delivery.option.name;
			orderData['delivery-option-cost'] = $scope.transport.delivery.option.price;
			orderData['delivery-time-slot-start'] = moment($scope.transport.delivery.timeStart,'HH:mm').format('HH:mm');
			orderData['delivery-time-slot-end'] = moment($scope.transport.delivery.timeEnd,'HH:mm').format('HH:mm');
		  }

		  if($scope.transport.collection.option){
			orderData['collection-option-id'] = $scope.transport.collection.option.carriage_surcharge_id;
			orderData['collection-option-name'] = $scope.transport.collection.option.name;
			orderData['collection-option-cost'] = $scope.transport.collection.option.price;
			orderData['collection-time-slot-start'] = moment($scope.transport.collection.timeStart,'HH:mm').format('HH:mm');
			orderData['collection-time-slot-end'] = moment($scope.transport.collection.timeEnd,'HH:mm').format('HH:mm');
		  }

		  if ($scope.quote.discountCode) {
				orderData['discounted-total-ex-vat'] = $scope.quote.discountedTotalExVat;
				orderData['discounted-total-inc-vat'] = $scope.quote.discountedTotalIncVat;
				orderData['discounted-vat'] = $scope.quote.discountedVat;
		  }

		  payment.saveOrder(orderData).then(function(response) {
		   //then store only needed info in the cache to be used in success page
		   //then redirect to success page
		   $timeout(function(){
			CacheFactory.get('appCache').put('success',response.data);
			$window.location.href = $scope.base_url+'checkout/success';
		   }, 50);

		  }, function(response) {
			if(response.status==400){
			  //then there are some limitations
			  $scope._error = 'Something went wrong, please call us to be able to assist you.'
			  helper.hideTransLoader();
			}
		  });
  }

  $scope.saveAddress = function(form,targetStep){
	  if(form.$valid){
		helper.showTransLoader();
		//hide results drop down
		var currentStep = $('form[name="'+form.$name+'"]').data('step');
		$scope.craftyResults[currentStep].foundAddresses = [];
		//set step to be filled
		$scope.steps[currentStep].filled = true;
		//trigger change step function
		$scope.changeStep(targetStep);
		$scope.checkTlifPrice();

		$timeout(function(){
		  //init paypal button
		  $scope.initPaypalBtn();
		}, 100);
		
		helper.hideTransLoader();
	  }
	}

	
	$scope.checkTlifPrice = function () {
		if (typeof $scope.quote.tlif != 'undefined') {
			// $scope.quote.tlif.paused = true;
			if ($scope.quote.tlif.enabled){
				
				$scope.quote.original = {};
				$scope.quote.original.totalIncVat = $scope.quote.totalIncVat;
				$scope.quote.original.totalExVat = $scope.quote.totalExVat;
				$scope.quote.original.vat = $scope.quote.vat;
	
				$scope.quote.totalIncVat = $scope.quote.tlif.totalIncVat;
				$scope.quote.totalExVat = $scope.quote.tlif.totalExVat;
				$scope.quote.vat = $scope.quote.tlif.vat;
				CacheFactory.get('appCache').put('quote',$scope.quote);

	
			} else if (typeof $scope.quote.original !='undefined'){
				
				$scope.quote.totalIncVat = $scope.quote.original.totalIncVat;
				$scope.quote.totalExVat = $scope.quote.original.totalExVat;
			$scope.quote.vat = $scope.quote.original.vat;
				
				CacheFactory.get('appCache').put('quote',$scope.quote);
			}
		}
	};
	

	$scope.initPaypalBtn = function(){
	  var orderID;
	  var prefix;
	  var accessToken;

	  var paymentData = {
		  webQuoteID:$scope.quote.webQuoteID,
		  amount:$('input[name=amount]').val(),
		  recipient_name:$scope.quote.name,
		  line1:$scope.address.billing.address1,
		  line2:($scope.address.billing.address2)? $scope.address.billing.address2 : '',
		  city:$scope.address.billing.town,
		  postal_code:$scope.address.billing.postCode,
		  phone:$scope.quote.telephone,
		  state:$scope.address.billing.county
	  };
	
	  paypal.Button.render({
	  
			  env: window.currentEnv

			  ,commit: true

			  ,payment: function(resolve, reject) {
				  // Set up the payment here, when the buyer clicks on the button
				  $('#stripe_error').addClass('ng-hide');
				  var CREATE_PAYMENT_URL = $('#base_url').val()+'/checkout/create-paypal-payment';
				  
				  paypal.request.post(CREATE_PAYMENT_URL,paymentData)
					  .then(function(data) { 
						  orderID = data.orderID;
						  prefix = data.prefix;
						  accessToken = data.accessToken;
						  resolve(data.paymentID); 
					  })
					  .catch(function(err) { reject(err);$scope.showError(err); });

			  },onAuthorize: function(data) {
				  // Execute the payment here, when the buyer approves the transaction
				  var EXECUTE_PAYMENT_URL = $('#base_url').val()+'/checkout/paypal-confirm';

				  paypal.request.post(EXECUTE_PAYMENT_URL,{ paymentID: data.paymentID, payerID: data.payerID, accessToken: accessToken, orderID:orderID })
						  
					  .then(function(data) {
						  $scope.saveOrder(data.orderID,data.transID);
					  })
					  .catch(function(err) { $scope.showError(err) });

			 },onError: function(err) {
				  // Show an error page here, when an error occurs
				  $scope.showError(err);
			  },style: {
				  size: 'medium',
				  color: 'gold',
				  shape: 'rect'
			  }
							  
	  }, '#paypal-button');

	}

	$scope.showError = function(){
		$('#stripe_error').html("Unfortunately your payment was not successful. Please review your payment details and try again, or contact your card issuer for further information.");
		$('#stripe_error').removeClass('ng-hide');
	}

	$scope.findAddress = function(type){
	  helper.showTransLoader();
	  $scope.craftyResults[type].error = null;
	  $scope.craftyResults[type].foundAddresses = [];
	  $scope.craftyResults[type].selectedAddress = '';
	   quote.getCraftyResults($scope.address[type].postCode).then(function(response) {
		if(response.data.results.length){
		  var addresses = response.data.results;
		  //loop through addresses
		  angular.forEach(addresses, function(address, key) {
			//and add all labels with id's
			$scope.craftyResults[type].foundAddresses.push({id:address.id,address:address.labels.join(' | ')});
		  });

		  $timeout(function(){
		  $('#billing_found_address').focus();
		   }, 100);

		  
		}else{
		  $scope.craftyResults[type].error = 'No Matching Address found!';
		}
		helper.hideTransLoader();
	  }, function(response) {
		$scope.craftyResults[type].error = 'No Matching Address found!';
		helper.hideTransLoader();
	  });
	}

	$scope.clearFoundAddresses = function(type){
	  $scope.craftyResults[type].foundAddresses = [];
	}

	$scope.selectFoundAddress = function(type){
	  helper.showTransLoader();
	  //query API to get address
		quote.selectCraftyAddress($scope.craftyResults[type].selectedAddress).then(function(response) {
		  //then fill address form
		  $scope.address[type].address1 = response.data.result.line_1;
		  $scope.address[type].address2 = response.data.result.line_2;
		  $scope.address[type].town = response.data.result.locality;
		  $scope.address[type].county = response.data.result.province_name;
		  $scope.address[type].country = 'GB';
		  $scope.address[type].postCode = response.data.result.postal_code;
		  helper.hideTransLoader();
	  }, function(response) {
		// console.log(response);
		helper.hideTransLoader();
	  });
	}

	$scope.changeStep = function(targetStep){
		
	  	//disable all the steps and activate the target step
		$scope.steps.billing.active = false;
		$scope.steps.payment.active = false;
		$scope.steps[targetStep].active = true;
		$scope.quote.tlif.paused = false;
		//cache address and go to next step
		$scope.cacheAddressStep();
		if(targetStep=='payment'){
			$scope.initStripe(); 
		}
	}

	$scope.cacheAddressStep = function(){
	  //cache address and go to next step
	  var addressData = {
		address:$scope.address,
		steps:$scope.steps
	  }
	  CacheFactory.get('appCache').put('addressData',addressData);
	}

	$scope.checkLimitations = function() {
		$http({
		method: 'POST',
		url: Config.api_url+'quote/check-limitations',
		data: {data: $scope.quote},
		headers:{
			'authorization':Config.api_key
		}
		}).then(function(response) {
			$scope.quote.quote_limitations = response.data
			CacheFactory.get("appCache").put("quote", $scope.quote);
			if(response.data.limitations == true){
			$window.location.href = $scope.base_url+'checkout/quote';
			}
		})
	}

	
	$scope.updateTlifStatus = function() {
		data = {
			token: $scope.quote.token,
			webquote_id: $scope.quote.webQuoteID
		}
		quote.updateTlifStatus(data)
	}
  
}]);
